module.exports = __webpack_public_path__ + "static/img/beta_bg_white_11.0eadcd3e.svg";